import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventStepComponent } from '../event/event-step.component';
import { VolunteerStepComponent } from '../volunteer/volunteer-step.component';
import { JobStepComponent } from '../job/job-step.component';
import { ScheduleStepComponent } from '../schedule/schedule-step.component';
import { ResultStepComponent } from '../result/result-step.component';
import { EventService } from '../../../core/services/event.service';
import { VolunteerService } from '../../../core/services/volunteer.service';
import { StaffService } from '../../../core/services/staff.service';
import { Event, CelebrationJobLocation } from '../../../core/models/event.model';
import { Volunteer } from '../../../core/models/volunteer.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-event-manager',
  standalone: true,
  imports: [
    CommonModule,
    EventStepComponent,
    VolunteerStepComponent,
    JobStepComponent,
    ScheduleStepComponent,
    ResultStepComponent,
    MatIcon
  ],
  templateUrl: './event-manager.component.html',
  styleUrls: ['./event-manager.component.scss'],
  providers: [EventService, VolunteerService, StaffService, MatSnackBar]
})

export class EventManagerComponent implements OnInit, OnDestroy {
  step = 0;
  selectedEvent: Event | null = null;
  volunteer: Volunteer | null = null;
  volunteerError: string | null = null;
  isLoadingVolunteer = false;
  selectedJobLocation: CelebrationJobLocation | null = null;
  scheduleData: any = null;
  staffCreated = false;
  resultMessage = '';
  isMobileScreen = false;
  constructor(
    private staffService: StaffService,
    private snackBar: MatSnackBar,
  ) {

  }

  ngOnInit() {
    this.checkMobileScreen();
    window.addEventListener('resize', this.checkMobileScreen.bind(this));
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.checkMobileScreen.bind(this));
  }

  checkMobileScreen() {
    this.isMobileScreen = window.innerWidth <= 600;
  }

  onEventStepSelected(event: Event) {
    this.selectedEvent = event;
    this.step = 1;
  }


  onVolunteerSelected(volunteer: Volunteer) {
    this.volunteer = volunteer;
    this.step = 2;
  }

  /** Voluntário agendado: pula a seleção de local e vai direto ao agendamento. */
  onIniciarLocalDefinido(payload: { volunteer: Volunteer; jobLocation: CelebrationJobLocation }) {
    this.volunteer = payload.volunteer;
    this.selectedJobLocation = payload.jobLocation;
    this.step = 3;
  }

  onJobSelected(jobLocation: CelebrationJobLocation) {
    this.selectedJobLocation = jobLocation;
    this.step = 3;
  }

  onScheduleConfirmed(schedule: any) {
    this.scheduleData = schedule;
    this.confirmarCadastro();
  }

  confirmarCadastro() {
    if (!this.selectedEvent || !this.volunteer || !this.selectedJobLocation || !this.scheduleData) {
      this.snackBar.open('Dados incompletos. Por favor, verifique todas as informações.', 'Fechar', { duration: 5000 });
      return;
    }
    const startDateTime = this.combineDateAndTime(new Date(this.scheduleData.startDate), this.scheduleData.startTime);
    const endDateTime = this.combineDateAndTime(new Date(this.scheduleData.endDate), this.scheduleData.endTime);
    const staffData = {
      memberId: this.volunteer.id,
      celebrationJobLocationId: this.selectedJobLocation.locationUuid,
      description: "",
      startDate: startDateTime.toISOString(),
      endDate: endDateTime.toISOString()
    };
    this.staffService.createStaff(staffData).subscribe({
      next: () => {
        this.staffCreated = true;
        this.resultMessage = 'Staff criado com sucesso!';
        this.step = 4;
      },
      error: () => {
        this.staffCreated = false;
        this.resultMessage = 'Erro ao criar staff. Por favor, tente novamente.';
        this.step = 4;
      }
    });
  }

  combineDateAndTime(date: Date, timeStr: string): Date {
    if (!date || !timeStr) return new Date();
    try {
      const [hours, minutes] = timeStr.split(':').map(Number);
      const result = new Date(date);
      result.setHours(hours || 0, minutes || 0, 0, 0);
      return result;
    } catch {
      return new Date();
    }
  }

  onResultFinish(action: number) {
    if (action === 1) {
      // Resetar tudo: voltar ao início do wizard
      this.selectedEvent = null;
      this.volunteer = null;
      this.selectedJobLocation = null;
      this.scheduleData = null;
      this.staffCreated = false;
      this.resultMessage = '';
      this.step = 0;
    } else if (action === 2) {
      // Adicionar outro staff no mesmo evento: manter evento, limpar o resto
      this.volunteer = null;
      this.selectedJobLocation = null;
      this.scheduleData = null;
      this.staffCreated = false;
      this.resultMessage = '';
      this.step = 1; // Volta para o step de voluntário
    }
  }

  // Permite clicar em etapas anteriores ou na atual, e só permite etapas futuras se as anteriores estiverem completas
  canGoToStep(index: number): boolean {
    // Etapa sempre acessível se for anterior ou igual à atual
    if (index <= this.step) return true;
    // Etapa 1 só se evento selecionado, etapa 2 só se voluntário selecionado, etc
    if (index === 1) return !!this.selectedEvent;
    if (index === 2) return !!this.selectedEvent && !!this.volunteer;
    if (index === 3) return !!this.selectedEvent && !!this.volunteer && !!this.selectedJobLocation;
    if (index === 4) return this.staffCreated;
    return false;
  }

  goToStep(index: number) {
    this.step = index;
  }

  get selectedVolunteer() {
    return this.volunteer;
  }
}
